import PropTypes from 'prop-types';
import { Squircle } from 'corner-smoothing';

import { useTheme } from '@mui/material/styles';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import { MIcon } from '../@material-extend';

const TipsCard = ({ tip, severity, ...other }) => {
  const theme = useTheme();
  const iconSize = 24;

  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sr'));
  let squirclePadding = theme.spacing(4);
  if (isSmallMobile) {
    squirclePadding = theme.spacing(2);
  }

  let color = '';
  let icon = {};
  let text = 'Information';
  switch (severity) {
    case 'error':
      color = theme.palette.error.lighter;
      icon = <MIcon icon="info" variant="critical" fontSize={iconSize} sx={{ transform: 'rotate(180deg)' }} />;
      break;
    case 'warn':
      color = theme.palette.warning.lighter;
      icon = <MIcon icon="warning_amber" variant="warning" fontSize={iconSize} />;
      break;
    case 'reminder':
      color = theme.palette.background.squircle;
      icon = <MIcon icon="lightbulb" variant="secondary" fontSize={iconSize} />;
      text = 'Rappel';
      break;
    default:
      color = theme.palette.background.squircle;
      icon = <MIcon icon="info" variant="secondary" fontSize={iconSize} />;
  }

  return (
    <Box {...other}>
      <Squircle cornerRadius={40} style={styleSquircle(squirclePadding, color)}>
        <Stack sx={styleTitleWrapper}>
          <Stack sx={styleIconWrapper(theme.palette.background.default)}>{icon}</Stack>
          <Typography variant="subtitle1" color="text.secondary">
            {text}
          </Typography>
        </Stack>
        <Typography align="center" color="text.secondary">
          {tip}
        </Typography>
      </Squircle>
    </Box>
  );
};

const styleSquircle = (padding, color) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12,
  padding,
  backgroundColor: color
});

const styleTitleWrapper = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1.5
};

const styleIconWrapper = (color) => ({
  p: 0.75,
  backgroundColor: color,
  borderRadius: '50%'
});

TipsCard.propTypes = {
  tip: PropTypes.string,
  severity: PropTypes.string
};

export default TipsCard;
